import { render, staticRenderFns } from "./KimsaCountdown.vue?vue&type=template&id=40ef4c1c&scoped=true&"
import script from "./KimsaCountdown.vue?vue&type=script&lang=js&"
export * from "./KimsaCountdown.vue?vue&type=script&lang=js&"
import style0 from "./KimsaCountdown.vue?vue&type=style&index=0&id=40ef4c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef4c1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
